import React from 'react';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { Card, Typography } from 'antd';

const VehicleAnalytics = ({ vehicleStats, getVehicleStats }) => {
	useEffect(() => {
		getVehicleStats();
	}, []);

	return (
		<div className="page">
			<div className="cards">
				<Card style={{ width: 220, backgroundColor: '#66c2ff' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Total Ads&apos; Clicks</p>
						<p className="card-value">
							{vehicleStats && vehicleStats.totalClicks && vehicleStats.totalClicks[0]?.totalClicks}
						</p>
					</Typography.Text>
				</Card>
				<Card style={{ width: 220, backgroundColor: '#ff80bf' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Total Ads&apos; Views</p>
						<p className="card-value">
							{vehicleStats && vehicleStats.totalViews && vehicleStats.totalViews[0]?.totalViews}
						</p>
					</Typography.Text>
				</Card>
				<Card style={{ width: 220, backgroundColor: '#71da71' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Call Clicks from Ad</p>
						<p className="card-value">
							{vehicleStats &&
								vehicleStats.totalNumberOfCallClicks &&
								vehicleStats.totalNumberOfCallClicks[0]?.totalNumberOfCallClicks}
						</p>
					</Typography.Text>
				</Card>
				<Card style={{ width: 220, backgroundColor: '#CCCC66' }} hoverable>
					<Typography.Text>
						<p className="card-heading"> User Profile Clicks from Ad</p>
						<p className="card-value">
							{vehicleStats &&
								vehicleStats.totalNumberOfProfileClicks &&
								vehicleStats.totalNumberOfProfileClicks[0]?.totalNumberOfProfileClicks}
						</p>
					</Typography.Text>
				</Card>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	vehicleStats: state.vehicleStats.vehicleStats,
});

const mapDispatchToProps = (dispatch) => ({
	getVehicleStats: () => dispatch(Actions.getVehicleStats()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleAnalytics));
